import React, { useEffect, useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getHistoryEntryTypes } from "../../../api/historyService";

const ProcedureAutocomplete = ({
  historyEntryTypeId = "",
  value,
  onChange,
  label = "Select Procedure",
  ...props
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getHistoryEntryTypes();
        setItems(response?.data || []);
      } catch (error) {
        console.error("Error fetching items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [historyEntryTypeId]);

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) => option.professional_name ? option.professional_name : option.name || ""}
      value={
        items.find((item) => item.id === value) || null
      }
      onChange={(event, newValue) =>
        onChange?.(newValue ? newValue.id : "")
      }
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default ProcedureAutocomplete;